import React, { memo, useEffect } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { oldRoutes } from "router/old-routes"
import { Button, Flex, Modal } from "antd"
import Input from "components/form/Input"

import { useTranslation } from "react-i18next"

import { useDispatch, useSelector } from "react-redux"
import { hideModal, resetModal, showModal } from "modules/modals/reducer"
import { modalSelector } from "modules/modals/selectors"
import styles from "./TemplateNameModal.module.css"

const TemplateNameModal = ({ form, changeHandler, isChanged }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const templateModal = useSelector(modalSelector("templateModal"))

  const openModal = () => dispatch(showModal("templateModal"))
  const closeModal = () => dispatch(hideModal("templateModal"))
  const handleAfterClose = () => {
    dispatch(resetModal("templateModal"))
    if (!form.name) navigate(oldRoutes.guideMarketingTemplatesParentsPath())
  }

  useEffect(() => {
    openModal()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      open={templateModal.isOpen}
      width={480}
      centered
      footer={null}
      onCancel={closeModal}
      afterClose={handleAfterClose}
    >
      <Flex vertical align="center" gap="large" className={styles.body}>
        <h3>{t("marketing.labels.name")}</h3>
        <Input
          id="name"
          type="text"
          name="name"
          placeholder={t("marketing.placeholders.name")}
          value={form.name || ""}
          onChange={changeHandler}
          className={styles.nameInput}
        />
        <Button
          type="primary"
          className={styles.submitButton}
          onClick={closeModal}
          disabled={!isChanged}
        >
          {t("global.next")}
        </Button>
      </Flex>
    </Modal>
  )
}

TemplateNameModal.propTypes = {
  form: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  changeHandler: PropTypes.func.isRequired,
  isChanged: PropTypes.bool.isRequired
}

export default memo(TemplateNameModal)
